import { Outlet } from "react-router";
import { AppSidebar } from "@/components/layout/app-sidebar";
import { Breadcrumbs } from "@/components/layout/breadcrumbs";
import type { NavEntry } from "@/components/layout/nav-items";
import { ThemeSwitcher } from "@/components/layout/theme-switcher";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

/**
 * The page frame shared by the tenant app and the platform console: collapsible sidebar, header with
 * breadcrumbs and theme switcher, and the routed page. Both shells decide what goes in the sidebar.
 */
export function ShellFrame({
  items,
  userLabel,
  userDescription,
  userEmail,
}: {
  items: NavEntry[];
  userLabel: string;
  userDescription?: string | undefined;
  userEmail: string;
}) {
  return (
    <SidebarProvider>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded-md focus:bg-primary focus:px-3 focus:py-2 focus:text-sm focus:text-primary-foreground"
      >
        Skip to content
      </a>
      <div className="print:hidden">
        <AppSidebar items={items} userLabel={userLabel} userDescription={userDescription} userEmail={userEmail} />
      </div>
      <SidebarInset>
        <header className="sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b bg-background/95 px-3 backdrop-blur supports-[backdrop-filter]:bg-background/60 print:hidden">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mx-1 h-4" />
          <Breadcrumbs />
          <div className="flex-1" />
          <ThemeSwitcher />
        </header>
        <main id="main-content" className="flex flex-1 flex-col p-4 md:p-6 print:p-0">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
